import { useQuery } from '@tanstack/react-query';
import { Endpoint, QueryKey } from '@/constants';
import { getData } from '@/utils/getData';

export const useGetCart = (enabled: boolean) => {
  const { data, isPending } = useQuery({
    enabled,
    queryFn: getData(Endpoint.GetCart),
    queryKey: [QueryKey.GetCart],
  });

  return { cartData: data?.data, isPending };
};
